import * as React from "react";
const SvgAssign = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.3333 10.5556L6.66667 10.5556L7.83333 11.7222M6.66667 7.44444L11.3333 7.44444L10.1667 6.27778M2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9Z", stroke: "#FF3B3B", style: {
  stroke: "#FF3B3B",
  stroke: "color(display-p3 1.0000 0.2314 0.2314)",
  strokeOpacity: 1
}, strokeWidth: 1.41, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgAssign;
